export default __webpack_public_path__ + "static/coorporate_1-cd03db0cefd9ebe2f22ee9f9a66b976a.png";